module.exports = __webpack_public_path__ + "img/4_wind.372d83da.jpg";